import React from 'react';
import { cn } from '@bridebook/aura';
import { PolymorphicComponentProps } from '@bridebook/aura/src/lib/type-helpers';
import { cva } from 'class-variance-authority';
import { keyBy } from 'lodash';

const typoVariantsArray = [
  'typo-2xs',
  'typo-xs',
  'typo-xs-semibold',
  'typo-sm',
  'typo-sm-semibold',
  'typo-base',
  'typo-base-semibold',
  'typo-lg',
  'typo-lg-semibold',
  'typo-xl-semibold',
  'typo-2xl-semibold',
  'typo-3xl-semibold',
  'typo-3xl-bold',
  'typo-4xl-semibold',
  'typo-4xl-bold',
  'typo-5xl-bold',
  'typo-6xl-bold',
  'typo-7xl-bold',
] as const;

type TypoVariant = (typeof typoVariantsArray)[number];
const typoVariantsObject = keyBy<TypoVariant>(typoVariantsArray);

// m-0 is to reset the maring that comes from our legacy normalizer
const textVariants = cva('m-0 text-space', {
  variants: {
    variant: typoVariantsObject,
  },
  defaultVariants: {
    variant: 'typo-base',
  },
});

type TextProps = {
  variant?: TypoVariant;
};

const defaultComponent = 'p';
export const Text = <C extends React.ElementType = typeof defaultComponent>({
  as,
  children,
  variant,
  className,
  ...props
}: PolymorphicComponentProps<C, TextProps>) => {
  const Component = as || defaultComponent;
  return (
    <Component className={cn(textVariants({ variant }), className)} {...props}>
      {children}
    </Component>
  );
};
